<div *ngIf="credits"  class="fullpage">
    <div  class="credits" [innerHTML]="credits | safe: 'html'"></div>
</div>